var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-layout" }, [
    _c("div", { staticClass: "mx-0 layout-all" }, [
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "col-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _vm._l(_vm.sections, function(section, j) {
                return [
                  section !== "Missing Driver's License Number" &&
                  _vm.checkSectionVisible(_vm.group[section])
                    ? _c(
                        "div",
                        {
                          key: j + "-section",
                          staticClass:
                            "col-12 col-md-12 px-0 mb-4 layout-section"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "mr-md-4 shadow-sm pb-2 rounded" },
                            [
                              section !== "untitled"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "py-2 mt-1 mb-2 pl-2 text-white rounded-top",
                                      class: {
                                        "product-section-heading-alert": _vm.checkAlertHeading(
                                          section
                                        ),
                                        "product-section-heading": !_vm.checkAlertHeading(
                                          section
                                        )
                                      }
                                    },
                                    [
                                      _vm.checkAlertHeading(section)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "float-left yellow-alert-hopd-head"
                                            },
                                            [_vm._m(0, true)]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("section-heading", {
                                        attrs: {
                                          section: section,
                                          pageData: _vm.pageData
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.subSections, function(subSection, k) {
                                return _vm.group[section][subSection]
                                  ? _c(
                                      "div",
                                      { key: k + "-subsections" },
                                      [
                                        subSection !== "untitled"
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "form-row mx-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col py-1 pl-2 my-2 ml-3 product-subsection-heading"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            role: "heading",
                                                            "aria-level": "4"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(subSection)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._l(_vm.subSubSections, function(
                                          subSubSection,
                                          l
                                        ) {
                                          return _vm.group[section][subSection][
                                            subSubSection
                                          ]
                                            ? _c(
                                                "div",
                                                {
                                                  key: l + "-sub-subsection",
                                                  class:
                                                    subSubSection === "untitled"
                                                      ? "col-md-12 px-0"
                                                      : "col-12 col-lg-6 px-0 mb-3"
                                                },
                                                [
                                                  subSubSection !== "untitled"
                                                    ? _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-row mx-0"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col py-1 pl-2 my-2 ml-3 product-subsection-heading"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      role:
                                                                        "heading",
                                                                      "aria-level":
                                                                        "4"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        subSubSection
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.group[section][
                                                      subSection
                                                    ][subSubSection],
                                                    function(fieldData, m) {
                                                      return [
                                                        fieldData.field_type ===
                                                          "text_inline_first" ||
                                                        fieldData.field_type ===
                                                          "radio_inline_first" ||
                                                        fieldData.field_type ===
                                                          "checkbox_inline_first" ||
                                                        fieldData.field_type ===
                                                          "select_inline_first"
                                                          ? _c("div", {
                                                              key: m + "-div"
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("form-block", {
                                                          key: m + "-formblock",
                                                          class: _vm.formBlockStyles(
                                                            fieldData
                                                          ),
                                                          attrs: {
                                                            formdata: fieldData,
                                                            formIndex: m
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-6" }, [
          _c("div", { staticClass: "form-row" }, [
            _vm.hasFields(
              "Missing Driver's License Number",
              _vm.pageData.fields
            )
              ? _c(
                  "div",
                  { staticClass: "col-12 col-md-12 px-0 mb-4 layout-section" },
                  [
                    _c("div", { staticClass: "shadow-sm pb-2 rounded" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pl-3" },
                        [
                          _vm._l(_vm.pageData.fields, function(item, key) {
                            return item.section ===
                              "Missing Driver's License Number" &&
                              item.visible == true
                              ? [
                                  _c(
                                    "div",
                                    {
                                      key: "header-key-" + key,
                                      staticClass:
                                        "py-1 pl-2 mt-1 bg-lt-blue dlv-heading",
                                      attrs: {
                                        role: "heading",
                                        "aria-level": "3"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.sub_section)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("form-block", {
                                    key: "formblock-key-" + key,
                                    staticClass: "form-group",
                                    attrs: { formdata: item }
                                  })
                                ]
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ])
                  ]
                )
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "fa-stack uniform-icon-size yellow-alert-hopd",
        attrs: { "data-v-201dd800": "" }
      },
      [
        _c("span", {
          staticClass: "fas fa-circle fa-stack-2x icon-incomplete",
          attrs: { "data-v-201dd800": "" }
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "fas fa-exclamation fa-stack-1x",
          staticStyle: { color: "rgb(255, 255, 255)" },
          attrs: { "data-v-201dd800": "" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-table mt-1" }, [
      _c("div", { staticClass: "d-table-cell qrp-error-background p-2" }, [
        _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
          _c("span", {
            staticClass: "fas fa-circle fa-stack-2x icon-incomplete",
            staticStyle: { color: "#BB0000" }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "fas fa-exclamation fa-stack-1x qrp-text-white"
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-table-cell w-100 pr-2 py-2 qrp-error-background text-dark-gray",
          attrs: { role: "alert", "aria-atomic": "true" }
        },
        [_vm._v("Missing Driver's License Number")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msdl-content px-3" }, [
      _c("span", [
        _vm._v(
          "Our reports were unable to acquire the driver’s license number for the following applicants. Branch requires this information to complete the policy and run reports."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2502a562", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2502a562","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/layouts/LayoutHopolicyDetails.vue
// module id = null
// module chunks = 